import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { toast } from 'react-hot-toast';
import { useQuery } from 'react-query';

const AllUser = () => {
    const { data: users = [],refetch } = useQuery({
        queryKey: ['users'],
        queryFn: async () => {
            const res = await fetch('https://denticare-server-sumonhasan55.vercel.app/users');
            const data = res.json();
            return data;
        }
    });

    const handleMakeAdmin =(id)=>{
        fetch(`https://denticare-server-sumonhasan55.vercel.app/users/admin/${id}`,{
            method:'PUT',
            headers:{
                authorization:`bearer ${localStorage.getItem('accessToken')}`
            }
        })
        .then(res=>res.json())
        .then(data=>{
            console.log(data)
            if(data.modifiedCount > 0){
               alert('Make Admin Successfully')
            }
            refetch()
        })

    }

    return (
        <div>
            <h1 className='text-3xl'>All Users</h1>

            <div className="overflow-x-auto">
                <table className="table table-zebra w-full">
                    {/* head */}
                    <thead>
                        <tr>
                            <th></th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Job</th>
                            <th>Modified</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            users?.map((user, i) => <tr
                                key={user._id}
                            >
                                <th>{i}</th>
                                <td>{user.name}</td>
                                <td>{user.email}</td>
                                <td>{user.role !== 'admin' && <button onClick={()=> handleMakeAdmin(user._id) } className='btn'>Make Admin</button>}
                                {user.role === 'admin' && <button className='btn btn-info text-white'>Admin</button>}
                                </td>
                                <td><button className='btn'>Remove User</button></td>
                            </tr>)


                        }

                    </tbody>
                </table>
            </div>
           






        </div>
    );
};

export default AllUser;